export default class UrlDataReader {
  public static toDataURL = async (url: string) => {
    console.log(url, '<=url');
    const response = await fetch(url);
    const blob = await response.blob();
    console.log(blob, '<=blob');

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        console.log(reader.result, '<=onloadend');
        resolve(reader.result);
      };
      reader.onerror = (ex) => {
        reject(ex);
      };
      reader.readAsDataURL(blob);
    });
  };
}
